import { Col, Row } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { CSSProperties, useEffect, useState } from "react";
import styled from "styled-components";
import { dateCommon } from "../../helpers/common";
import { getLoaiChamCong} from "../../services/chamcong";
import { useSelector } from "react-redux";
import { NhanVienResponse } from "../../models/nhanvien/NhanVien";
import { layDanhMucNhanVien } from "../../services/danhmuc";
import { chucVu } from "../../constants";

const PrintPage = styled.div`
  @media print {
    /* Thiết lập lề và kích thước giấy A4 */
    @page upright {
        size: portrait;
        page-orientation: upright;
        background-color: white;
        margin-top: 0.5cm;
        margin-bottom: 2cm;
        margin-left: 1cm;
        margin-right: 1cm;
    }
    .upright{
        page:upright;
    }
    div {
      font-family:'Times New Roman',Times,serif !important;
    }
    label {
      font-family:'Times New Roman',Times,serif !important;
    }
    .ant-table-tbody {
        padding: 0 !important;
    }
    .ant-table-tbody > tr > td {
        padding: 0 !important;
    }
    .atn-table-summary {
        display: table-header-group;
    }
  }
`;
const cssFormInNoiDungTien: CSSProperties = {
    textAlign: "right",
    paddingRight: "4px",
    fontFamily: 'Times New Roman'
};
const cssFormInNoiDungBenTrai: CSSProperties = {
    textAlign: "left",
    paddingRight: "5px",
    fontFamily: 'Times New Roman'
};

const emptyTextStyle = {
    color: 'black',
    fontWeight: 'bold',
    fontFamily: 'Times New Roman',
};

const InChamCongThang = ({ ThongKeChamCong, thangNam }: { ThongKeChamCong: any, thangNam: any }) => {

    const [dataTable, setDataTable] = useState<any>();
    const [chanhVP, setChanhVP] = useState<NhanVienResponse>();
    const [giamDoc, setGiamDoc] = useState<NhanVienResponse>();
    const user = useSelector((state: any) => state.auth.currentUser);
    const now = new Date();
    const [columns, setColumns] = useState<any>();

    type dataType = {
        key?: any,
        hoVaTen?: any,
        X?: any,
        L?: any,
        P?: any,
        O?: any,
        TS?: any,
        CT?: any,
        H?: any,
        KL?: any,
        nn?: any,
        STT?: any,
        anCa?: any,
        ctp?: any,
        ncltt?: any,
        tongCong?: any,
        kyHieu?: any,
        ma?:any,
        BHXH?:any,
        Nb?:any,
        Cô?:any,
        W?:any,
    };
    const layChanhVanPhong = async () => {
        let rs = await layDanhMucNhanVien();
        setChanhVP(rs.filter((item: any) => item.idChucVu == chucVu.chanhVanPhong)[0])
        setGiamDoc(rs.filter((item: any) => item.idChucVu == chucVu.giamDoc)[0])
    }
    const layDuLieu = async () => {
        var data: dataType[] = [];
        ThongKeChamCong.map((item: any, index: any) => {
            data.push({
                key: index + 1,
                STT: index + 1,
                hoVaTen: <div style={cssFormInNoiDungBenTrai}>{item.hoTen}</div>,
                nn: <div style={cssFormInNoiDungTien}><strong>{item.ctcc.filter((x: any) => x.ngayNghiCoLuong).length}</strong></div>,
                anCa: <strong>{item.ctcc.filter((x: any) => x.anCa).length}</strong> ,
                ctp: <strong>{item.ctcc.filter((x: any) => x.congTacPhi).length}</strong>,
                ncltt: <strong>{item.ctcc.filter((x: any) => x.cong).length}</strong>,
                tongCong: <div style={cssFormInNoiDungTien}><strong>{item.ctcc.filter((x: any) => x.cong).length}</strong></div>,

                X: item.chiTiet.filter((x: any) => x.ma === "X")[0] ?
                    <strong >{item.chiTiet.filter((x: any) => x.ma === "X")[0].soLuong !== 0 ?
                        item.chiTiet.filter((x: any) => x.ma === "X")[0].soLuong : "-"}</strong>: "",

                L: item.chiTiet.filter((x: any) => x.ma === "L")[0] ?
                    <div style={cssFormInNoiDungTien}><strong>{item.chiTiet.filter((x: any) => x.ma === "L")[0].soLuong !== 0 ?
                        item.chiTiet.filter((x: any) => x.ma === "L")[0].soLuong : "-"}</strong></div> : "",

                P: item.chiTiet.filter((x: any) => x.ma === "P")[0] ?
                    <div style={cssFormInNoiDungTien}><strong>{item.chiTiet.filter((x: any) => x.ma === "P")[0].soLuong !== 0 ?
                        item.chiTiet.filter((x: any) => x.ma === "P")[0].soLuong : "-"}</strong></div> : "",

                O: item.chiTiet.filter((x: any) => x.ma === "O")[0] ?
                    <div style={cssFormInNoiDungTien}><strong>{item.chiTiet.filter((x: any) => x.ma === "O")[0].soLuong !== 0 ?
                        item.chiTiet.filter((x: any) => x.ma === "O")[0].soLuong : "-"}</strong></div> : "",

                TS: item.chiTiet.filter((x: any) => x.ma === "TS")[0] ?
                    <div style={cssFormInNoiDungTien}><strong>{item.chiTiet.filter((x: any) => x.ma === "TS")[0].soLuong !== 0 ?
                        item.chiTiet.filter((x: any) => x.ma === "TS")[0].soLuong : "-"}</strong></div> : "",

                CT: item.chiTiet.filter((x: any) => x.ma === "CT")[0] ?
                    <div style={cssFormInNoiDungTien}><strong>{item.chiTiet.filter((x: any) => x.ma === "CT")[0].soLuong !== 0 ?
                        item.chiTiet.filter((x: any) => x.ma === "CT")[0].soLuong : "-"}</strong></div> : "",

                H: item.chiTiet.filter((x: any) => x.ma === "H")[0] ?
                    <div style={cssFormInNoiDungTien}><strong>{item.chiTiet.filter((x: any) => x.ma === "H")[0].soLuong !== 0 ?
                        item.chiTiet.filter((x: any) => x.ma === "H")[0].soLuong : "-"}</strong></div> : "",

                KL: item.chiTiet.filter((x: any) => x.ma === "KL")[0] ?
                    <div style={cssFormInNoiDungTien}><strong>{item.chiTiet.filter((x: any) => x.ma === "KL")[0].soLuong !== 0 ?
                        item.chiTiet.filter((x: any) => x.ma === "KL")[0].soLuong : "-"}</strong></div> : "",

                BHXH: item.chiTiet.filter((x: any) => x.ma === "BHXH")[0] ?
                    <div style={cssFormInNoiDungTien}><strong>{item.chiTiet.filter((x: any) => x.ma === "BHXH")[0].soLuong !== 0 ?
                        item.chiTiet.filter((x: any) => x.ma === "BHXH")[0].soLuong : "-"}</strong></div> : "",

                Cô: item.chiTiet.filter((x: any) => x.ma === "Cô")[0] ?
                    <div style={cssFormInNoiDungTien}><strong>{item.chiTiet.filter((x: any) => x.ma === "Cô")[0].soLuong !== 0 ?
                        item.chiTiet.filter((x: any) => x.ma === "Cô")[0].soLuong : "-"}</strong></div> : "",

                W: item.chiTiet.filter((x: any) => x.ma === "W")[0] ?
                    <div style={cssFormInNoiDungTien}><strong>{item.chiTiet.filter((x: any) => x.ma === "W")[0].soLuong !== 0 ?
                        item.chiTiet.filter((x: any) => x.ma === "W")[0].soLuong : "-"}</strong></div> : "",

                Nb: item.chiTiet.filter((x: any) => x.ma === "Nb")[0] ?
                    <div style={cssFormInNoiDungTien}><strong>{item.chiTiet.filter((x: any) => x.ma === "Nb")[0].soLuong !== 0 ?
                        item.chiTiet.filter((x: any) => x.ma === "Nb")[0].soLuong : "-"}</strong></div> : "",
            })
        })
        setDataTable(data);
    }

    const layColumns = async () => {
        var data = await getLoaiChamCong();
        var columnsChildren: ColumnsType<dataType> = [];
        data.map((item: any, index: any) => {
            columnsChildren.push({
                title: item.kyHieu,
                dataIndex: item.ma,
                key: item.kyHieu,
                align: 'center',
                width: '3%',
            })
        })

        var columnsCha: ColumnsType<dataType> = [
            {
                title: 'STT',
                dataIndex: 'STT',
                key: 'STT',
                width: '3%',
                align: 'center'
            },
            {
                title: 'Họ và tên',
                dataIndex: 'hoVaTen',
                key: 'hoVaTen',
                width: '17%',
                align: 'center'
            },
            {
                title: 'Quy ra công (ngày)',
                key: 'quyRaCongGio',
                align: 'center',
                children: columnsChildren
            },
            {
                title: 'Ngày nghỉ, học tập, CT có hưởng lương',
                dataIndex: 'nn',
                key: 'nn',
                align: 'center',
                width: '7%'
            },
            {
                title: 'Ăn ca',
                dataIndex: 'anCa',
                key: 'anCa',
                align: 'center',
                width: '7%'
            },
            {
                title: 'CTP',
                dataIndex: 'ctp',
                key: 'ctp',
                align: 'center',
                width: '7%'
            },
            {
                title: 'NCLTT',
                dataIndex: 'ncltt',
                key: 'ncltt',
                align: 'center',
                width: '7%'
            },
            {
                title: 'Tổng cộng',
                dataIndex: 'tongCong',
                key: 'tongCong',
                align: 'center',
                width: '7%',
            },
            {
                title: 'Ghi chú',
                dataIndex: 'ghiChu',
                key: 'ghiChu',
                align: 'center'
            },
        ];
        setColumns(columnsCha);
    }

    useEffect(() => {
        layColumns();
        layChanhVanPhong();
        layDuLieu();
    }, [ThongKeChamCong])

    return (
        <section>
            <div style={{ backgroundColor: 'white' }}>
                <PrintPage >
                <div className="upright">
                    <div className="text-center pt-2">
                        <Row gutter={8}>
                                <Col span={12} >
                                    <div style={{ fontFamily: 'Times New Roman' }}>ỦY BAN NHÂN DÂN THÀNH PHỐ<br /><label><span style={{ fontFamily: 'Times New Roman' }}> QUỸ ĐẦU TƯ PHÁT TRIỂN</span><hr style={{ borderTop: "1px solid", width: "60%", marginLeft: '12mm', marginTop: "1px", marginBottom: "2px" }} /> </label></div>
                                </Col>
                                <Col span={12}  >
                                    <label style={{ fontFamily: 'Times New Roman' }}>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM <br /> <span style={{ fontFamily: 'Times New Roman' }}>Độc lập - Tự do  - Hạnh phúc</span><hr style={{ borderTop: "1px solid", width: "50%", marginLeft: '18mm', marginTop: "1px", marginBottom: "2px" }} /> </label>
                                </Col>
                        </Row>
                        <Row>
                            <Col span={24} className="pt-4">
                                    <label style={{ fontFamily: 'Times New Roman' }}>BẢNG TỔNG HỢP CHẤM CÔNG <br /> Tháng {dateCommon.formatDate(thangNam, "MM")} năm {dateCommon.formatDate(thangNam, "yyyy")} </label>
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col span="24">
                            <div className="card-primary">
                                <Table
                                    dataSource={dataTable}
                                    pagination={false}
                                    size="small"
                                    columns={columns}
                                    locale={{ emptyText: <span style={emptyTextStyle}>Không có dữ liệu</span> }}
                                    className="custom-table-anttd"
                                />
                            </div>
                        </Col>
                        </Row>
                    <div className="print-footer">
                        <div className="text-center" style={{ marginTop: '25px' }}>
                            <Row gutter={8}>
                                <Col span={8} >
                                </Col>
                                <Col span={8} >
                                </Col>
                                <Col span={8}  >
                                        <div className="font-italic" style={{ fontFamily: 'Times New Roman' }}>Đà Nẵng, ngày {("0" + now.getDate()).slice(-2)} tháng {("0" + (now.getMonth() + 1)).slice(-2)} năm {now.getFullYear()}</div>
                                </Col>
                            </Row>
                            <Row gutter={8}>
                                <Col span={8} >
                                        <label style={{ fontFamily: 'Times New Roman' }}>Người lập</label>
                                </Col><Col span={8} >
                                        <label style={{ fontFamily: 'Times New Roman' }}>Chánh Văn phòng</label>
                                </Col>
                                <Col span={8}  >
                                        <label style={{ fontFamily: 'Times New Roman' }}>Giám đốc</label>
                                </Col>
                            </Row>
                        </div>
                        <div className="text-center" style={{ paddingTop: "100px" }}>
                            <Row gutter={8}>
                                <Col span={8}  >
                                        <label style={{ fontFamily: 'Times New Roman' }}>{user?.hoTen}</label>
                                </Col>
                                <Col span={8} >
                                        <label style={{ fontFamily: 'Times New Roman' }}>{chanhVP?.hoTen}</label>
                                </Col>
                                <Col span={8}  >
                                        <label style={{ fontFamily: 'Times New Roman' }}>{giamDoc?.hoTen}</label>
                                </Col>
                            </Row>
                         </div>
                     </div>
                </div>
                </PrintPage>
            </div>
        </section>
    )
}
export default InChamCongThang;
